import type { ValidationError } from '../api.ts';
import type { Deal, DealFormState, DealParticipant, DealState, DealsListState } from '../deal.ts';
import type { DealForecast } from '../dealForecasting.ts';

import type { BulkDeleteState, ExportState } from './state.ts';

export type DealForecastContextualEstimate = {
  impressions: number | null;
  market_requests: number | null;
};

export type DealForecastState = {
  audience_monthly_requests?: number | null;
  contextual_estimate?: DealForecastContextualEstimate | null;
  deal_participants?: DealParticipant[];
  // biome-ignore lint/suspicious/noExplicitAny: any is needed here
  error?: any;
  forecast?: DealForecast;
  job_id?: string;
  loading?: boolean;
  not_included_fields?: string[];
  package_loading?: boolean;
  disabled?: boolean;
};
export interface DealsState<T extends Partial<Deal> = DealState> {
  dealsLandingList: DealsListState<T>;
  dealsList: DealsListState<T>;
  dealsExport: ExportState;
  dealForm: DealFormState<T>;
  dealBulkDelete: BulkDeleteState;
  dealForecast: DealForecastState;
}

export interface DealsBaseState<T extends DealState = DealState> {
  deals: DealsState<T>;
}

export const DealForecastActionType = {
  CANCEL_FORECAST: 'deals/CANCEL_FORECAST',
  DEAL_FORECAST_PACKAGE_LOADING: 'deals/DEAL_FORECAST_PACKAGE_LOADING',
  FORECAST_REQUEST_ERROR: 'deals/FORECAST_REQUEST_ERROR',
  FORECAST_REQUEST_LOADING: 'deals/FORECAST_REQUEST_LOADING',
  FORECAST_REQUEST_SUCCESS: 'deals/FORECAST_REQUEST_SUCCESS',
  FORECAST_UPDATE_DEAL_PARTICIPANTS: 'deals/FORECAST_UPDATE_DEAL_PARTICIPANTS',
  GENERATE_FORECAST_BUTTON_DISABLED: 'deals/GENERATE_FORECAST_BUTTON_DISABLED',
  GET_JOB_ID_SUCCESS: 'deals/GET_JOB_ID_SUCCESS',
  RESET_FORECAST: 'deals/RESET_FORECAST',
};

export type DealForecastAction = {
  audience_monthly_requests?: number | null;
  contextual_estimate?: DealForecastContextualEstimate | null;
  deal_participants?: DealParticipant[];
  disabled?: boolean;
  error?: ValidationError<Error>;
  forecast?: DealForecast;
  not_included_fields?: string[];
  job_id?: string;
  package_loading?: boolean;
  type: string;
};
